import pluralize from "pluralize";
import camelCase from "camelcase";

export const calculateOperationName = (
  resource: string,
  operationType: "getOne" | "getList" | "create" | "update" | "delete"
): string => {
  const singularResource = pluralize.singular(resource);

  switch (operationType) {
    case "getOne":
      return camelCase(singularResource);
    case "getList":
      return resource;
    case "create":
      return camelCase(`create-${singularResource}`);
    case "update":
      return camelCase(`update-${singularResource}`);
    case "delete":
      return camelCase(`delete-${singularResource}`);
    default:
      return resource;
  }
};

export const calculateInputType = (
  resource: string,
  affix: string,
  { required = false, position = "suffix" }: { required?: boolean; position?: "prefix" | "suffix" } = {}
): string => {
  const singularResource = pluralize.singular(resource);
  const parts = position === "prefix" ? [affix, singularResource] : [singularResource, affix];
  return `${camelCase(parts.join("-"), { pascalCase: true })}Input${required ? "!" : ""}`;
};
